export default function PayPalPreview({src}) {
    return (
        <div
            className='paypal-block-editor'
            style={{
                height: '40px',
                maxHeight: '40px',
                backgroundColor: '#ffc439',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
            <img
                src={src}
                style={{
                    width: '100%',
                    height: '25px',
                    objectFit: 'contain'
                }}/>
        </div>
    )
}